import { FaceRecognitionStatusEnum, LayoutEnum } from '@goldcast/api/content';
import { FeatureFlagKeys } from '@/services/featureFlag';
import featureFlagStore from '@/stores/featureFlagStore';
import { Clip, LayoutStatus } from '@/domains/asset';
import { isCustomUpload } from '@/libs/clipContentUtil';

export function getLayoutAvailabilityStatus(
  clipLayout: LayoutEnum,
  layoutStatus: Clip['layout_status'],
  useNewPlayer: boolean = false
): FaceRecognitionStatusEnum | null {
  if (useNewPlayer && !isCustomUpload()) {
    return null;
  }

  if (!(clipLayout === 'SPEAKER' || clipLayout === 'GRID' || clipLayout === 'FOCUS')) {
    return null;
  }
  const speakerLayoutStatusInfo = layoutStatus[clipLayout === 'FOCUS' ? 'GRID' : clipLayout] as LayoutStatus;
  const featureFlags = featureFlagStore.getSnapshot();

  const shouldUseAccurateOnly = featureFlags[FeatureFlagKeys.Use_CL_Fast_Accurate];

  if (speakerLayoutStatusInfo.status === 'DONE') {
    if (shouldUseAccurateOnly && speakerLayoutStatusInfo.accurate === false) {
      return 'PROCESSING';
    }

    return 'DONE';
  }

  if (
    speakerLayoutStatusInfo.status === 'PROCESSING' ||
    speakerLayoutStatusInfo.status === 'FAILED' ||
    speakerLayoutStatusInfo.status === 'UNAVAILABLE'
  ) {
    return speakerLayoutStatusInfo.status;
  }

  return null;
}

export const SCREENSHARE_TOAST_MESSAGE =
  'Screenshare detected. Update track selection in scenes to show or hide the screenshare stream.';

export function hasShownScreenshareToast(clipId: string): boolean {
  try {
    return localStorage.getItem(`screenshareDetectionToastShown_${clipId}`) === 'true';
  } catch {
    return false;
  }
}

export function markScreenshareToastAsShown(clipId: string): void {
  try {
    localStorage.setItem(`screenshareDetectionToastShown_${clipId}`, 'true');
  } catch {
    // Silently handle localStorage errors
  }
}
